var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.9996C4.00006 11.7344 4.10545 11.4801 4.293 11.2926L10.293 5.29259C10.4816 5.11043 10.7342 5.00964 10.9964 5.01192C11.2586 5.0142 11.5094 5.11937 11.6948 5.30477C11.8802 5.49018 11.9854 5.741 11.9877 6.00319C11.99 6.26539 11.8892 6.51799 11.707 6.70659L7.414 10.9996L19 10.9996C19.2652 10.9996 19.5196 11.105 19.7071 11.2925C19.8946 11.48 20 11.7344 20 11.9996C20 12.2648 19.8946 12.5192 19.7071 12.7067C19.5196 12.8942 19.2652 12.9996 19 12.9996L7.414 12.9996L11.707 17.2926C11.8892 17.4812 11.99 17.7338 11.9877 17.996C11.9854 18.2582 11.8802 18.509 11.6948 18.6944C11.5094 18.8798 11.2586 18.985 10.9964 18.9873C10.7342 18.9895 10.4816 18.8888 10.293 18.7066L4.293 12.7066C4.10545 12.5191 4.00006 12.2648 4 11.9996Z",
    fill: "#80BE78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiArrowUp);
export default __webpack_public_path__ + "static/media/mi_arrow-up.36559d1e2918b88389643bdcee2e8347.svg";
export { ForwardRef as ReactComponent };